/* eslint-disable prettier/prettier */
<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 v-if="tipo" class="fs-1x fw-bolder mb-10">
          Registro de {{ tipo }}
        </h2>
        <h2 v-else class="fs-1x fw-bolder mb-10">Registro de Orden Judicial</h2>
        <p v-if="tipo" class="text-gray-600 fs-6 fw-bold mb-5">
          <span>Obtención de datos para {{ tipo }} del ppl</span>
        </p>
        <p v-else class="text-gray-600 fs-6 fw-bold mb-5">
          <span
            >Obtención de datos de la orden judicial, juzgados, delitos y
            otros.</span
          >
        </p>
        <div class="row">
          <div class="col-md-6">
            <p class="round3">
              Los campos marcados con (<span style="color: red"> * </span>) son
              de llenado obligatorio.
            </p>
          </div>
        </div>
        <div class="row">
          <!-- fecha mandamiento -->
          <div class="col-md-4 mt-3">
            <label class="form-label required">Fecha mandamiento:</label>
            <Field
              name="fecha_mandamiento"
              v-slot="{ field }"
              v-model="formData.fecha_mandamiento"
            >
              <Datepicker
                v-bind="field"
                uid="fecha_mandamiento"
                v-model="formData.fecha_mandamiento"
                type="date"
                locale="es"
                cancelText="Cancelar"
                selectText="Seleccionar"
                monthNameFormat="long"
                :enableTimePicker="false"
                :format="format"
                :previewFormat="format"
                :maxDate="currentDate"
                required
              ></Datepicker>
            </Field>
            <ErrorMessage
              name="fecha_mandamiento"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- fecha ingreso al recinto penitenciario -->
          <div v-if="!tipo" class="col-md-4 mt-3">
            <label class="form-label required"
              >Fecha de ingreso al recinto:</label
            >
            <Field
              name="fecha_ingreso"
              v-slot="{ field }"
              v-model="formData.fecha_ingreso"
            >
              <Datepicker
                v-bind="field"
                uid="fecha_ingreso"
                v-model="formData.fecha_ingreso"
                type="date"
                locale="es"
                cancelText="Cancelar"
                selectText="Seleccionar"
                monthNameFormat="long"
                :enableTimePicker="false"
                :format="format"
                :maxDate="currentDate"
                required
                :previewFormat="format"
                @update:modelValue="limpiarFechaSalida"
              ></Datepicker>
            </Field>
            <ErrorMessage
              name="fecha_ingreso"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- tipo mandamiento -->
          <div class="col-md-4 mt-3">
            <label class="form-label required">Tipo Mandamiento:</label>
            <Field
              name="tipo_mandamiento"
              v-slot="{ field }"
              v-model="formData.tipo_mandamiento"
            >
              <select
                v-bind="field"
                class="form-select fuente"
                aria-label="select"
                v-model="formData.tipo_mandamiento"
                :onchange="habilitarSentencia(formData.tipo_mandamiento)"
              >
                <option
                  v-for="(list, key) in typeOrdersList"
                  :value="list.id_tipo_mandamiento"
                  :key="key"
                >
                  {{ list.descripcion_tipo_mandamiento }}
                </option>
              </select>
            </Field>
            <ErrorMessage
              name="tipo_mandamiento"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!--  años de sentencia-->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3">
            <label class="form-label required">Años de sentencia:</label>
            <Field
              name="anios_sentencia"
              v-slot="{ field }"
              v-model.trim="formData.anios_sentencia"
            >
              <input
                v-bind="field"
                type="number"
                class="form-control fuente"
                min="1"
                max="30"
                maxlength="2"
                pattern="^(0|[1-9][0-9]?)$"
                id="anios_sentencia"
                placeholder="ingresar de 1 a 30 (años)"
                v-model.trim="formData.anios_sentencia"
                @keyup="deleteZeros"
                @input="cambioMeses(formData.anios_sentencia)"
              />
            </Field>
            <ErrorMessage
              name="anios_sentencia"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- meses de sentencia -->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3">
            <label class="form-label required">Meses de sentencia:</label>
            <Field
              name="meses_sentencia"
              v-slot="{ field }"
              v-model.trim="formData.meses_sentencia"
            >
              <input
                v-bind="field"
                name="meses_sentencia"
                type="number"
                class="form-control fuente"
                min="0"
                max="11"
                maxlength="2"
                pattern="^(0|[1-9][0-9]?)$"
                id="anios_sentencia"
                placeholder="ingresar de 0 a 11 (meses)"
                v-model.trim="formData.meses_sentencia"
                :disabled="
                  !formData.anios_sentencia || formData.anios_sentencia == 30
                "
                @keyup="deleteZeros"
                @input="calcularFechaSalida(formData.meses_sentencia)"
              />
            </Field>
            <ErrorMessage
              name="meses_sentencia"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!--  fecha salida según sentencia-->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3">
            <label class="form-label required"
              >Fecha salida según sentencia:</label
            >
            <Field
              name="fecha_salida"
              v-slot="{ field }"
              v-model="formData.fecha_salida"
            >
              <Datepicker
                v-bind="field"
                uid="fecha_salida"
                v-model="formData.fecha_salida"
                type="date"
                locale="es"
                cancelText="Cancelar"
                selectText="Seleccionar"
                monthNameFormat="long"
                :enableTimePicker="false"
                :format="format"
                :previewFormat="format"
                :minDate="currentDate"
                :disabled="!formData.habilitarFechaSalida"
                required
              ></Datepicker>
            </Field>
            <ErrorMessage
              name="fecha_salida"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- activar fecha salida manual -->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3 float-right">
            <label class="form-label">Fecha salida manual:</label> <br />
            <Field
              name="habilitarFechaSalida"
              v-slot="{ field }"
              v-model="formData.habilitarFechaSalida"
            >
              <div class="form-check form-switch mt-2">
                <input
                  v-bind="field"
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  v-model="formData.habilitarFechaSalida"
                />
                <label class="form-check-label" for="flexSwitchCheckDefault">
                  {{
                    formData.habilitarFechaSalida == true
                      ? "Habilitado"
                      : "Deshabilitado"
                  }}</label
                >
              </div>
            </Field>
          </div>
          <!-- nombre juez -->
          <div class="col-md-4 mt-3">
            <label class="form-label required">Nombre completo del juez:</label>
            <Field
              name="nombre_juez"
              v-slot="{ field }"
              v-model="formData.nombre_juez"
            >
              <input
                v-bind="field"
                type="text"
                class="form-control fuente"
                id="juez"
                style="text-transform: uppercase"
                v-model="formData.nombre_juez"
              />
            </Field>
            <ErrorMessage
              name="nombre_juez"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- nombre juzgado -->
          <div class="col-md-4 mt-3">
            <label class="form-label required">Juzgado:</label>
            <Field
              name="nombre_juzgado"
              v-slot="{ field }"
              v-model="formData.nombre_juzgado"
            >
              <input
                v-bind="field"
                type="text"
                class="form-control fuente"
                id="cod_mandamiento"
                style="text-transform: uppercase"
                v-model.trim="formData.nombre_juzgado"
              />
            </Field>
            <ErrorMessage
              name="nombre_juzgado"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- tipo juzgado -->
          <div class="col-md-4 mt-3">
            <label class="form-label required">Tipo Juzgado:</label>
            <Field
              name="tipo_juzgado"
              v-slot="{ field }"
              v-model="formData.tipo_juzgado"
            >
              <select
                v-model="formData.tipo_juzgado"
                class="form-select fuente"
                aria-label="select"
                v-bind="field"
              >
                <option
                  v-for="(list, key) in typeCourtsList"
                  :value="list.id_tipo_juzgado"
                  :key="key"
                  :disabled="list.descripcion_tipo_juzgado === 'NO APLICA'"
                >
                  {{ list.descripcion_tipo_juzgado }}
                </option>
              </select>
            </Field>
            <ErrorMessage
              name="tipo_juzgado"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- tipo código -->
          <div class="col-md-4 mt-3">
            <label class="form-label required">Tipo de Código:</label>
            <Field
              name="tipo_codigo"
              v-slot="{ field }"
              v-model="formData.tipo_codigo"
            >
              <select
                v-model="formData.tipo_codigo"
                class="form-select fuente"
                aria-label="select"
                v-bind="field"
                :onchange="disabledCodMandamiento(formData.tipo_codigo)"
              >
                <option
                  v-for="(list, key) in typeCodesList"
                  :value="list.id_tipo_codigo"
                  :key="key"
                  :disabled="list.nombre_codigo === 'RESOLUCIÓN ADMINISTRATIVA'"
                >
                  {{ list.nombre_codigo }}
                </option>
              </select>
            </Field>
            <ErrorMessage
              name="tipo_codigo"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- código único -->
          <div class="col-md-4 mt-3">
            <label class="form-label required"
              >Código único de mandamiento:</label
            >
            <Field
              name="codigo_mandamiento"
              v-slot="{ field }"
              v-model="formData.codigo_mandamiento"
            >
              <input
                v-bind="field"
                type="text"
                class="form-control fuente"
                id="cod_mandamiento"
                style="text-transform: uppercase"
                v-model="formData.codigo_mandamiento"
                :disabled="!codMandamiento"
              />
            </Field>
            <ErrorMessage
              name="codigo_mandamiento"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- centro penitenciario -->
          <div class="col-md-4 mt-3">
            <label class="form-label required">Recinto de reclusión:</label>
            <Field
              name="centro_penitenciario"
              v-slot="{ field }"
              v-model="formData.centro_penitenciario"
            >
              <select
                v-model="formData.centro_penitenciario"
                class="form-select fuente"
                aria-label="select"
                v-bind="field"
              >
                <option
                  v-for="(list, key) in prisionNamesList"
                  :value="list.id_recinto_penitenciario"
                  :key="key"
                  :disabled="
                    list.nombre_recinto_penitenciario === 'TODOS' ||
                    (rol === 'filiador' &&
                      list.id_recinto_penitenciario !== id_recinto)
                  "
                >
                  {{ list.nombre_recinto_penitenciario }}
                </option>
              </select>
            </Field>
            <ErrorMessage
              name="centro_penitenciario"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          <!-- delitos -->
          <div class="col-md-8 mt-3">
            <!--begin::Label-->
            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
              <span class="required">Delitos</span>
              <i
                class="fas fa-exclamation-circle ms-2 fs-7"
                data-bs-toggle="tooltip"
                title="Puede seleccionar uno o más delitos"
              ></i>
            </label>
            <el-form>
              <el-form-item>
                <Field
                  name="delitos"
                  v-slot="{ field }"
                  v-model="formData.delitos"
                >
                  <el-select
                    v-bind="field"
                    v-model="formData.delitos"
                    @change="require_relationship()"
                    multiple
                    placeholder="Presione para seleccionar"
                    style="display: block"
                  >
                    <el-option
                      v-for="(list, key) in crimesList"
                      :key="key"
                      :label="list.descripcion_delito"
                      :value="list.id_delito"
                      :disabled="
                        list.descripcion_delito !== 'ASISTENCIA FAMILIAR' &&
                        list.descripcion_delito !== 'BENEFICIOS SOCIALES' &&
                        tipo_mandamiento === 'APREMIO'
                      "
                    >
                    </el-option>
                  </el-select>
                </Field>
                <ErrorMessage
                  name="delitos"
                  class="fv-plugins-message-container invalid-feedback"
                ></ErrorMessage>
              </el-form-item>
            </el-form>
          </div>
          <!-- seguido por -->
          <div class="col-md-4 mt-3">
            <label class="form-label">Seguido por:</label>
            <Field
              name="seguido_por"
              v-slot="{ field }"
              v-model="formData.seguido_por"
            >
              <input
                v-bind="field"
                type="text"
                class="form-control fuente"
                id="seguido_por"
                style="text-transform: uppercase"
                v-model="formData.seguido_por"
              />
            </Field>
          </div>
          <div 
            class="row"
            v-if="formData.es_requerido_relacion"
          >
            <div class="col-md-6 mt-3">
              <label class="form-label">Relación con la Supuesta Victima:</label>
              <Field
                name="relacion_posible_victima"
                v-slot="{ field }"
                v-model="formData.relacion_posible_victima"
              >
                <select
                  v-model="formData.relacion_posible_victima"
                  class="form-select fuente"
                  aria-label="select"
                  v-bind="field"
                  style="text-transform: uppercase"
                  @change="selectRelationship()"
                >
                  <option
                    v-for="(list, key) in relationshipList"
                    :value="list.id_parentesco"
                    :key="key"
                  >
                    {{ list.nombre_parentesco }}
                  </option>
                </select>
              </Field>
              <ErrorMessage
                name="relacion_posible_victima"
                class="fv-plugins-message-container invalid-feedback"
              ></ErrorMessage>
            </div>
            <div 
              class="col-md-6 mt-3"
              v-if="formData.es_requerido_nombre_relacion_no_aplica"
            >
            <label class="form-label">Otra relación:</label>
            <Field
              name="nombre_relacion_no_aplica"
              v-slot="{ field }"
              v-model="formData.nombre_relacion_no_aplica"
            >
              <input
                v-bind="field"
                type="text"
                class="form-control fuente"
                id="nombre_relacion_no_aplica"
                style="text-transform: uppercase"
                v-model="formData.nombre_relacion_no_aplica"
              />
            </Field>
            <ErrorMessage
              name="nombre_relacion_no_aplica"
              class="fv-plugins-message-container invalid-feedback"
            ></ErrorMessage>
          </div>
          </div>
          <!-- observaciones -->
          <div class="col-md-12 mt-3">
            <label class="form-label">Observaciones:</label>
            <Field
              name="observacionOrdenes"
              v-slot="{ field }"
              v-model="formData.observacionOrdenes"
            >
              <textarea
                v-bind="field"
                class="form-control fuente"
                id="telefonoCelular"
                min="1"
                pattern="^[0-9]+"
                style="text-transform: uppercase"
                v-model="formData.observacionOrdenes"
              />
            </Field>
          </div>
          <Field
            name="estado"
            style="display: none"
            v-model="formData.estado"
          />
          <Field
            name="es_requerido_relacion"
            style="display: none"
            v-model="formData.es_requerido_relacion"
          />
          <Field
            name="es_requerido_nombre_relacion_no_aplica"
            style="display: none"
            v-model="formData.es_requerido_nombre_relacion_no_aplica"
          />
        </div>
      </div>
    </div>
    <div
      v-if="tipo === 'add_order'"
      class="m-10 d-flex justify-content-end align-items-right"
    >
      <a @click="RegisterNewOrder(orderDetails)" class="btn btn-primary btn-bg"
        >Registrar</a
      >
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";
import date from "date-and-time";
import es from "date-and-time/locale/es";
//import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Field, ErrorMessage } from "vee-validate";
import { addMonths } from "date-fns";
import formatDate from "@/helpers/formatDate";
import filiation from "@/filiation/composables/useFiliation";
import useAuth from "@/auth/composables/useAuth";
import { useRoute } from "vue-router";
import { object } from "yup/lib/locale";
export default defineComponent({
  name: "registerCourtOrder",
  components: {
    Datepicker,
    //vSelect,
    Field,
    ErrorMessage,
  },
  setup() {
    date.locale(es);
    const route = useRoute();
    const now = new Date();
    const pattern = date.compile("MM DD YYYY");
    const currentDate = date.format(now, pattern);
    const courtsList = ref([]);
    const typeCourtsList = ref([]);
    const typeCodesList = ref([]);
    const typeOrdersList = ref([]);
    const prisionNamesList = ref([]);
    const relationshipList = ref([]);
    const crimesList = ref([]);
    const codMandamiento = ref(true);
    const tiempo_sentencia = ref(false);
    const tipo_mandamiento = ref("");
    const id_recinto_peniteciario = JSON.parse(localStorage.getItem("user")).cod_recinto_penitenciario_real;
    const formData = ref({
      fecha_mandamiento: "",
      fecha_ingreso: "",
      anios_sentencia: "",
      meses_sentencia: "",
      fecha_salida: "",
      habilitarFechaSalida: false,
      tipo_mandamiento: "",
      nombre_juez: "",
      nombre_juzgado: "",
      tipo_juzgado: "",
      codigo_mandamiento: "",
      tipo_codigo: "",
      centro_penitenciario: "",
      delitos: [],
      seguido_por: null,
      relacion_posible_victima:"",
      es_requerido_relacion:false,
      nombre_relacion_no_aplica:"",
      es_requerido_nombre_relacion_no_aplica: false,
      observacionOrdenes: "",
      estado: false,
    });
    //funcion para formatear fecha
    const format = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
    } = useAuth();
    //importar funciones de useFiliation.js
    const {
      typeCourts,
      typeCodes,
      typeOrders,
      prisionNames,
      crimes,
      relationships,
      dataToEdit,
    } = filiation();
    //listar juzgados
    // importar "nameCourts" desde filiation si es necesario
    // const listNameCourts = async () => {
    //   const { data } = await nameCourts();
    //   courtsList.value = data;
    // };
    const relationship = async () => {
      const { data } = await relationships();
      relationshipList.value = data;
    };
    //listar tipos de juzgados
    const listTypeCourts = async () => {
      const { data } = await typeCourts();
      typeCourtsList.value = data;
    };
    //listar tipos de códigos
    const listTypeCodes = async () => {
      const { data } = await typeCodes();
      typeCodesList.value = data;
    };
    //listar tipos de ordenes
    const listTypeOrders = async () => {
      const { data } = await typeOrders();
      const list = ["SENTENCIADO", "PREVENTIVO", "APREMIO"];
      const orders = data.filter((el) =>
        list.includes(el.descripcion_tipo_mandamiento)
      );
      typeOrdersList.value = orders;
    };
    //Listar recintos penitenciarios
    const listPrisionNames = async () => {
      const { data } = await prisionNames();
      if (rol.value === "filiador") {
        const filteredPrisionNames = data.filter(
          (item) =>
            item.id_recinto_penitenciario === id_recinto_peniteciario &&
            item.nombre_recinto_penitenciario !== "TODOS"
        );
        prisionNamesList.value = filteredPrisionNames;
        formData.value.centro_penitenciario = filteredPrisionNames[0].id_recinto_penitenciario;
      } else if (rol.value === "supervisor") {
        const filteredPrisionNames = data.filter(
          (item) =>
            item.departamento === departamento_supervisar.value &&
            item.nombre_recinto_penitenciario !== "TODOS"
        );
        prisionNamesList.value = filteredPrisionNames;
      } else {
        const filteredPrisionNames = data.filter(
          (item) => item.nombre_recinto_penitenciario !== "TODOS"
        );
        prisionNamesList.value = filteredPrisionNames;
      }
    };
    //Listar delitos
    const listCrimes = async () => {
      const { data } = await crimes();
      crimesList.value = data;
    };
    const require_relationship = async () =>{
      let listIncluded =[];
      let isTrue = false;
      if (formData.value.delitos.length===0) {
        formData.value.relacion_posible_victima=''             
      }
        formData.value.delitos.map(id => {
          const obj = crimesList.value.find(o => o.id_delito === id && o.requiere_parentesco_victima);
          if (obj) {
            listIncluded.push(true)
          } else{
             formData.value.relacion_posible_victima='' 
          }
        });  
      isTrue = listIncluded.includes(true)
      formData.value.es_requerido_relacion=isTrue;
      return isTrue
    };
    const selectRelationship = () =>{
       const obj = relationshipList.value.find(o => o.id_parentesco === formData.value.relacion_posible_victima && o.nombre_parentesco ==='OTRO' );
        if(obj){ 
          formData.value.es_requerido_nombre_relacion_no_aplica=true
         }else{
           formData.value.es_requerido_nombre_relacion_no_aplica=false
           formData.value.nombre_relacion_no_aplica =''
         }
    }
    const disabledCodMandamiento = async (id_codigo) => {
      const found = typeCodesList.value.find(
        (element) => element.id_tipo_codigo == id_codigo
      );
      if (found === undefined) {
        return;
      } else {
        if (found.nombre_codigo === "SIN CÓDIGO") {
          codMandamiento.value = false;
          formData.value.codigo_mandamiento = "SIN CÓDIGO";
        } else {
          codMandamiento.value = true;
        }
      }
    };
    const habilitarSentencia = (id) => {
      const found = typeOrdersList.value.find(
        (element) => element.id_tipo_mandamiento == id
      );
      if (found === undefined) {
        return;
      } else {
        if (found.descripcion_tipo_mandamiento === "SENTENCIADO") {
          tiempo_sentencia.value = true;
          formData.value.estado = true;
          tipo_mandamiento.value = "";
        } else if (found.descripcion_tipo_mandamiento === "APREMIO") {
          tipo_mandamiento.value = "APREMIO";
          tiempo_sentencia.value = false;
          formData.value.anios_sentencia = "";
          formData.value.meses_sentencia = "";
          formData.value.fecha_salida = "";
          formData.value.habilitarFechaSalida = false;
          formData.value.estado = true;
        } else if (found.descripcion_tipo_mandamiento === "PREVENTIVO") {
          tiempo_sentencia.value = false;
          formData.value.anios_sentencia = "";
          formData.value.meses_sentencia = "";
          formData.value.fecha_salida = "";
          formData.value.habilitarFechaSalida = false;
          formData.value.estado = true;
          tipo_mandamiento.value = "";
        }
      }
    };
    const deleteZeros = (e) => {
      var key = e.keyCode || e.charCode;
      if (
        (key == 48 || key == 96) &&
        formData.value.anios_sentencia[0] == "0"
      ) {
        formData.value.anios_sentencia = formData.value.anios_sentencia.replace(
          /^0+/,
          ""
        );
      } else if (
        (key == 48 || key == 96) &&
        (formData.value.meses_sentencia[1] == "0" ||
          formData.value.meses_sentencia[1] == 0)
      ) {
        formData.value.meses_sentencia = formData.value.meses_sentencia.replace(
          /^0+/,
          ""
        );
      }
    };
    const calcularFechaSalida = (mes) => {
      const anio = Number(formData.value.anios_sentencia) * 12;
      const total = Number(anio) + Number(mes);
      let valor;
      if (anio == 360) {
        valor = addMonths(Date.parse(formData.value.fecha_ingreso), anio);
        return (formData.value.fecha_salida = valor);
      } else {
        mes == ""
          ? (formData.value.fecha_salida = null)
          : (valor = addMonths(
              Date.parse(formData.value.fecha_ingreso),
              total
            ));
        return (formData.value.fecha_salida = valor);
      }
    };
    const limpiarFechaSalida = () => {
      formData.value.anios_sentencia = "";
      formData.value.fecha_salida = "";
      formData.value.meses_sentencia = "";
      formData.value.tipo_mandamiento = "";
      formData.value.habilitarFechaSalida = false;
    };
    const cambioMeses = async (anios) => {
      calcularFechaSalida(formData.value.meses_sentencia);
      anios == 30
        ? (formData.value.meses_sentencia = "0")
        : formData.value.meses_sentencia;
      calcularFechaSalida(formData.value.meses_sentencia);
    };
    const RegisterNewOrder = (id) => {
      //console.log(id);
    };
    const dataEdit = computed(() => dataToEdit.value);
    const personDetails = computed(() => route.params.id_persona);
    const orderDetails = computed(() => route.params.id_orden_judicial);
    const tipo = computed(() => route.params.tipo);
    onMounted(async() => {
      setCurrentPageBreadcrumbs("Registro orden judicial", [
        "Privado de libertad",
      ]);
      //listNameCourts();
      listTypeCourts();
      listTypeCodes();
      listTypeOrders();
      listPrisionNames();
      await listCrimes();
      await relationship();
      //inicio cargado de datos para edición
      if (personDetails.value !== "0" && orderDetails.value !== "0") {
        const data = JSON.parse(localStorage.getItem("edit") || "{}");
        if (Object.entries(data).length !== 0) {
          formData.value.fecha_mandamiento = data.general[0].fecha_orden_judicial;
          formData.value.nombre_juez = data.general[0].nombre_completo_juez;
          formData.value.fecha_ingreso = data.general[0].fecha_ingreso_recinto;
          formData.value.tipo_mandamiento = data.general[0].cod_tipo_mandamiento;
          formData.value.anios_sentencia = data.general[0].anios_sentencia;
          formData.value.meses_sentencia = String(data.general[0].meses_sentencia);
          formData.value.fecha_salida = data.general[0].fecha_salida_sentencia;
          formData.value.habilitarFechaSalida = data.general[0].fecha_salida_manual;
          formData.value.tipo_mandamiento = data.general[0].cod_tipo_mandamiento;
          formData.value.nombre_juez = data.general[0].nombre_completo_juez;
          formData.value.nombre_juzgado = data.general[0].nombre_juzgado;
          formData.value.tipo_juzgado = data.general[0].cod_tipo_juzgado;
          formData.value.codigo_mandamiento = data.general[0].codigo_unico;
          formData.value.tipo_codigo = data.general[0].cod_tipo_codigo;
          formData.value.centro_penitenciario = data.general[0].cod_recinto_penitenciario;
          formData.value.seguido_por = data.general[0].seguido_por;
          formData.value.observacionOrdenes = data.general[0].obs_ordenes;
          formData.value.estado = data.general[0].estado_ordenes;
          formData.value.relacion_posible_victima = data.general[0].relacion_posible_victima;
          formData.value.nombre_relacion_no_aplica = data.general[0].nombre_relacion_no_aplica;
          for (let id_delito of data.delitos) {
            formData.value.delitos.push(id_delito.cod_delito);
          }
          await require_relationship();
          if (data.general[0].relacion_posible_victima) {
            const resp = relationshipList.value.find((parentesco)=>parentesco.id_parentesco==data.general[0].relacion_posible_victima)
            resp.nombre_parentesco==='OTRO'?formData.value.es_requerido_nombre_relacion_no_aplica=true:formData.value.es_requerido_nombre_relacion_no_aplica=false;
          }
          calcularFechaSalida(formData.value.meses_sentencia);
        }
      }
      //fin cargado de datos para edición
    });
    return {
      orderDetails,
      personDetails,
      tipo,
      currentDate,
      courtsList,
      typeCourtsList,
      typeCodesList,
      typeOrdersList,
      prisionNamesList,
      crimesList,
      relationshipList,
      formData,
      codMandamiento,
      dataToEdit,
      dataEdit,
      format,
      setCurrentPageBreadcrumbs,
      //listNameCourts,
      listTypeCourts,
      listTypeCodes,
      listPrisionNames,
      listCrimes,
      disabledCodMandamiento,
      habilitarSentencia,
      cambioMeses,
      deleteZeros,
      calcularFechaSalida,
      limpiarFechaSalida,
      RegisterNewOrder,
      tiempo_sentencia,
      tipo_mandamiento,
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
      require_relationship,
      selectRelationship,
    };
  },
});
</script>
<style>
p.round3 {
  border: 1px solid;
  border-radius: 5px;
  border-left-width: 7px;
  border-left-color: #037915;
  padding: 10px;
}
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
</style>
